import type { RadioOption, Option } from '@atlassian/jira-issue-field-radio-group';

export const transformDefaultValue = ({ id, value }: RadioOption): Option => ({
	label: value,
	value: id,
	testId: id,
});
